import React from "react";
import Seo from "../components/common/Seo";

const PrivacyPolicy = () => {
  return (
    <>
      <Seo
        title="Política de Privacidad"
        description="Política de privacidad de TransXSur. Información sobre el tratamiento de tus datos personales."
        url="https://www.transxsur.com/politica-privacidad"
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-display font-bold mb-8 text-[#1e5939]">
          Política de Privacidad
        </h1>
        <div className="prose max-w-none text-gray-700 space-y-6">
          <p>
            En TransXSur nos tomamos muy en serio la protección de tus datos
            personales. Esta política explica qué información recogemos, con qué
            fines y qué derechos te asisten.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            1. Responsable del tratamiento
          </h2>
          <ul className="list-disc pl-6">
            <li>
              <strong>Identidad:</strong> Pedro Ernesto Pérez Griñán
            </li>
            <li>
              <strong>NIF/CIF:</strong> Y7423875H
            </li>
            <li>
              <strong>Dirección postal:</strong> La Barca de la Florida, Jerez
              de la Frontera, Cádiz
            </li>
            <li>
              <strong>Correo electrónico:</strong> info@transxsur.com
            </li>
            <li>
              <strong>Teléfono:</strong> +34 643 49 53 51
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            2. Finalidad del tratamiento
          </h2>
          <p>
            Los datos personales que nos facilites a través del formulario de
            contacto, solicitud de presupuesto o vía email serán utilizados
            únicamente para:
          </p>
          <ul className="list-disc pl-6">
            <li>
              Gestionar y responder a tus consultas o solicitudes de
              presupuesto.
            </li>
            <li>
              Prestar los servicios de transporte, mudanzas o mensajería que nos
              contrates.
            </li>
            <li>
              Enviar comunicaciones comerciales únicamente si nos has dado tu
              consentimiento expreso.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            3. Legitimación
          </h2>
          <p>
            La base legal para el tratamiento de tus datos es la ejecución de un
            posible contrato de servicios o la aplicación de medidas
            precontractuales (como atender tu solicitud de presupuesto). El
            consentimiento explícito para cualquier otro fin (por ejemplo, envío
            de newsletters) se solicitará de forma independiente.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            4. Conservación de los datos
          </h2>
          <p>
            Tus datos se conservarán mientras mantengamos una relación
            comercial, mientras no solicites su supresión o durante el tiempo
            necesario para cumplir con obligaciones legales. Pasado este
            período, se eliminarán de forma segura.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            5. Comunicación de datos a terceros
          </h2>
          <p>
            No se cederán tus datos personales a terceros, salvo obligación
            legal. No realizamos transferencias internacionales de datos.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            6. Derechos del usuario
          </h2>
          <p>
            Puedes ejercer en cualquier momento tus derechos de acceso,
            rectificación, supresión, oposición, limitación del tratamiento y
            portabilidad, mediante escrito a la dirección postal o electrónica
            indicada en el punto 1, adjuntando copia de tu DNI o documento
            equivalente.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            7. Medidas de seguridad
          </h2>
          <p>
            Aplicamos las medidas técnicas y organizativas necesarias para
            garantizar la seguridad de tus datos y evitar su alteración, pérdida
            o acceso no autorizado.
          </p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
